import { AgentProject } from '../agent-project/agent-project.js'
import { ADK_VERSION, formatCode } from './utils.js'
import { createFile } from '../utils/fs.js'
import path from 'path'

export async function generateActionTypes(project: AgentProject): Promise<void> {
  // Generate action definitions
  const actionDefs: string[] = []

  for (const action of project.actions) {
    // Skip actions with visibility: hidden from type generation
    if (action.definition.attributes?.visibility === 'hidden') {
      continue
    }

    try {
      // Skip built-in actions that don't have a real file path
      if (action.path === '<adk:builtin>') {
        // For built-in actions, use the definition directly since we can't import them
        // Built-in actions should already have proper input/output schemas in their definitions
        actionDefs.push(`    "${action.definition.name}": {
      input: any;
      output: any;
    };`)
        continue
      }

      // Import the action module to get the actual instance
      const absolutePath = path.join(project.path, action.path)
      // Bust module cache to ensure fresh action on type generation
      const actionModule = await import(`${absolutePath}?t=${Date.now()}`)
      const actionInstance = actionModule[action.export] || actionModule.default

      if (actionInstance && actionInstance.input && actionInstance.output) {
        // Convert Zod schemas to TypeScript types
        const inputType = actionInstance.input.toTypescriptType ? actionInstance.input.toTypescriptType() : 'any'
        const outputType = actionInstance.output.toTypescriptType ? actionInstance.output.toTypescriptType() : 'any'

        actionDefs.push(`    "${action.definition.name}": {
      input: ${inputType};
      output: ${outputType};
    };`)
      }
    } catch (error) {
      console.warn(`Warning: Could not process action ${action.definition.name}:`, error)
      actionDefs.push(`    "${action.definition.name}": {
      input: any;
      output: any;
    };`)
    }
  }

  const content = `
////////////////////////////////////////////////////////
// DO NOT EDIT THIS FILE DIRECTLY
// This file is auto-generated from the Botpress ADK
// ADK Version: ${ADK_VERSION}
// Generated at: ${new Date().toISOString()}
////////////////////////////////////////////////////////

declare module "@botpress/runtime/_types/actions" {

  export interface CallableAction<I, O> {
    (input: I): Promise<O>;
    asTool(): import("@botpress/runtime").Autonomous.Tool;
  }

  export type BotActionDefinitions = {
${actionDefs.join('\n')}
  };
  
  export type BotActions = {
    [K in keyof BotActionDefinitions]:
      CallableAction<BotActionDefinitions[K]["input"], BotActionDefinitions[K]["output"]>
  };
}
`

  // Write to action-types.d.ts in the .adk folder
  const actionTypesPath = path.join(project.path, '.adk', 'action-types.d.ts')
  await createFile(actionTypesPath, await formatCode(content))
}
